import { doubleEncode, makePutRequest } from "../../utils";

type RecoverSession_sRecordingsOptions = {
	sessionId: string;
};
const recoverSession_sRecordings = async (
	token: string,
	options: RecoverSession_sRecordingsOptions,
) => {
	await makePutRequest({
		token,
		pathList: [
			"v2",
			"videosdk",
			"sessions",
			doubleEncode(options.sessionId),
			"recordings",
			"status",
		],
		options: {},
		body: {
			action: "recover",
		},
	});
	return 204;
};

export const curriedRecoverSession_sRecordings = (token: string) => (
	options: RecoverSession_sRecordingsOptions,
) => recoverSession_sRecordings(token, options);
